if (!customElements.get('compare-split')) {
  customElements.define('compare-split', class extends HTMLElement {
    connectedCallback() {
      this._cursor = this.querySelector('.before-after__cursor');

      if (!this._cursor) {
        return;
      }

      this._dragging = false;
      this._offsetX = this._currentX = 0;
      this._abortController = new AbortController();
      const signal = this._abortController.signal;

      this.addEventListener('pointerdown', this._onPointerDown.bind(this), { signal });
      this.addEventListener('pointermove', this._onPointerMove.bind(this), { signal });
      this.addEventListener('pointerup', this._onPointerUp.bind(this), { signal });
      this.addEventListener('pointercancel', this._onPointerUp.bind(this), { signal });
      this._cursor.addEventListener('keydown', this._onKeydown.bind(this), { signal });
      window.addEventListener('resize', this._recalculateOffset.bind(this), { signal });

      this._recalculateOffset();
    }

    disconnectedCallback() {
      this._abortController?.abort();
    }

    get minOffset() {
      return -this._cursor.offsetLeft - (document.dir === 'rtl' ? this._cursor.clientWidth : 0);
    }

    get maxOffset() {
      return this._cursor.offsetParent.clientWidth + this.minOffset;
    }

    _applyOffset(offset) {
      this._currentX = Math.min(Math.max(offset, this.minOffset), this.maxOffset);
      this._offsetX = this._currentX;
      this.style.setProperty('--clip-path-offset', `${this._currentX.toFixed(1)}px`);
      this._syncValueNow();
    }

    _syncValueNow() {
      if (this._cursor.getAttribute('role') !== 'slider' || !this._cursor.offsetParent) {
        return;
      }

      const range = this.maxOffset - this.minOffset;

      if (!range) {
        return;
      }

      const percent = Math.round(((this._currentX - this.minOffset) / range) * 100);
      this._cursor.setAttribute('aria-valuenow', String(percent));
    }

    _onPointerDown(event) {
      if (event.target === this._cursor || this._cursor.contains(event.target)) {
        this._initialX = event.clientX - this._offsetX;
        this._dragging = true;
        this.setPointerCapture(event.pointerId);
      }
    }

    _onPointerMove(event) {
      if (!this._dragging) {
        return;
      }

      this._applyOffset(event.clientX - this._initialX);
    }

    _onPointerUp() {
      this._dragging = false;
    }

    _recalculateOffset() {
      this._applyOffset(this._currentX);
    }

    _onKeydown(event) {
      if (event.code !== 'ArrowLeft' && event.code !== 'ArrowRight') {
        return;
      }

      event.preventDefault();
      this._applyOffset(event.code === 'ArrowLeft' ? this._currentX - 8 : this._currentX + 8);
    }
  });
}
